// ProductCarousel.jsx
import { Link } from 'react-router-dom'
import { Carousel } from 'react-bootstrap'

const ProductCarousel = ({ products }) => {
  return (
    <Carousel pause="hover" className="hero-carousel mb-4" indicators={false}>
      {products.map((product) => (
        <Carousel.Item key={product._id}>
          <Link to={`/product/${product._id}`} className="hero-carousel-link">
            <img src={product.image} alt={product.name} fluid="true" />
            <Carousel.Caption className="carousel-caption">
              <span>Featured Drop</span>
              <h2>{product.name}</h2>
              <p>${product.price}</p>
            </Carousel.Caption>
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default ProductCarousel
